import styled from 'styled-components'

export const SButtonsGroupContainer = styled.div`
    margin-top: ${({ theme }) => theme.sizing.margin.m};
    margin-bottom: ${({ theme }) => theme.sizing.margin.m};
    display: flex;
    justify-content: space-between;
    gap: 10px;

    &.action-btns {
        justify-content: flex-end;
    }
`
